<template>
	<textarea
		:class="variantCls.root"
		:value="value"
		:rows="rows"
		:disabled="disabled"
		v-on="{
			...computedListeners,
			input: event => $emit('input', event.target.value)
		}"
	/>
</template>

<script>
export default {
	props: {
		variant: {
			type: String,
			default: "default"
		},
		value: {
			required: true,
			default: "",
			validator(val) {
				return val === null || typeof val === "string"
			}
		},
		rows: {
			required: false,
			default: 10,
			type: Number
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},

	computed: {
		computedListeners() {
			return this.disabled ? {} : this.$listeners
		},
		variantCls() {
			return this.$store.getters.variants("JInputLongText", this.variant).el
		}
	}
}
</script>
